// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerText___9\\+XwI{font-size:22px}\n", "",{"version":3,"sources":["webpack://./src/routes/Simulations/components/SimulationsHeader/SimulationsHeader.css"],"names":[],"mappings":"AAAA,qBACI,cAAA","sourcesContent":[".headerText {\n    font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerText": "headerText___9+XwI"
};
export default ___CSS_LOADER_EXPORT___;
